import React, { useState } from 'react';

const SelectReports = ({ title, fetchReports }) => {
    const [month, setMonth] = useState('');
    const [year, setYear] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = () => {
        if (!month || !year) {
            setError('Please select both month and year.');
            return;
        }
        setError('');
        const selectedDate = `${year}-${month}`;
        fetchReports(selectedDate); // Trigger the fetch function
    };

    return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap:10,
                justifyContent: 'center',
                alignItems: 'center', // Ensures vertical centering
                margin: '20px auto', // Centers the div horizontally
                padding: '40px',
                width: '100%', // Adjusts width to fit content
                border: '2px solid',
                borderRadius: '10px',
                minHeight: '290px', // Ensures a minimum height

            }}>
                
                <h2>{title}</h2>

                {/* Select dropdown for month */}
                <select
                    value={month}
                    onChange={(e) => setMonth(e.target.value)}
                    style={{ padding: '5px', textAlign: 'center' }}
                >
                    <option value="">Month</option>
                    {Array.from({ length: 12 }, (_, index) => {
                        const value = (index + 1).toString().padStart(2, '0');
                        return (
                            <option key={value} value={value}>
                                {new Date(0, index).toLocaleString('default', { month: 'long' })}
                            </option>
                        );
                    })}
                </select>

                {/* Select dropdown for year */}
                <select
                    value={year}
                    onChange={(e) => setYear(e.target.value)}
                    style={{ padding: '5px', textAlign: 'center' }}
                >
                    <option value="">Year</option>
                    {Array.from({ length: 10 }, (_, index) => {
                        const value = new Date().getFullYear() - index;
                        return (
                            <option key={value} value={value}>
                                {value}
                            </option>
                        );
                    })}
                </select>

                {/* Submit button */}
                <button
                    className="hoverable"
                    onClick={handleSubmit}
                    style={{
                        padding: '5px 10px',
                        width: '100%',
                        backgroundColor: '#007bff',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                    }}
                >
                    Submit
                </button>

            {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
        </div>
    );
};

export default SelectReports;
